'use client';

import { useState } from 'react';
import AuthBrand from './AuthBrand';
import AuthForm from './AuthForm';

export default function AuthScreen() {
  const [mode, setMode] = useState<'signup' | 'signin'>('signup');

  return (
    <div className="min-h-screen bg-background flex">
      {/* Left brand panel */}
      <AuthBrand />

      {/* Right form panel */}
      <div className="flex-1 flex items-center justify-center p-6 lg:p-12 relative">
        {/* Background subtle grid */}
        <div className="absolute inset-0 bg-grid-pattern opacity-30" />

        <div className="relative z-10 w-full max-w-md">
          <AuthForm mode={mode} onModeChange={setMode} />
        </div>
      </div>
    </div>
  );
}